export enum ProcessEngineApiCall {
  START = <any>'START'
}
